import { render, staticRenderFns } from "./MyShipment.vue?vue&type=template&id=a5721a30&"
import script from "./MyShipment.vue?vue&type=script&lang=js&"
export * from "./MyShipment.vue?vue&type=script&lang=js&"
import style0 from "./MyShipment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MyShipment.vue"
export default component.exports